import React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import Loader from 'oxyrion-ui/lib/Loader';
import Label from 'oxyrion-ui/lib/Label/Label';
// import Icon from 'oxyrion-ui/lib/Icon';
import { connect } from '../../../../Store';
import { __, getIdFromProps } from '../../../../Utils';
import { catalogDescTranslate } from '../../../ProductCatalog/CatalogUtils';
import { LoaderWrapper } from '../../../../Components/ReusableComponents';
import Products from '../../../ProductCatalog/Components/Products';
import ProductQuantitySelect from '../../../../Components/ProductQuantitySelect';
import AlertPopup from '../../../../Components/AlertPopup';
import ErrorMessage from '../../../../Components/ErrorMessage';
import API2 from '../../../../API2';

const MainWrapper = styled.div`
  padding: ${rem(20)};
  margin-top: ${rem(40)};
  padding-bottom: ${rem(30)};
  display: flex;
  flex-direction: column;
`;

const BaseInfoWrapper = styled.div`
  max-width: ${rem(1200)};
  width: 100%;
`;

const Title = styled.div`
  font-size: ${rem(26)};
  font-weight: 700;
  color: #434245;
  margin-bottom: ${rem(10)};
`;

const ShortDesc = styled.div`
  font-size: ${rem(14)};
  font-weight: 200;
  color: #434245;
  margin-bottom: ${rem(10)};
`;

const Desc = styled.div`
  font-size: ${rem(16)};
  margin-bottom: ${rem(40)};
  color: #434245;
  text-align: justify;
`;

const Line = styled.div`
  height: ${rem(1)};
  width: 100%;
  min-width: ${rem(300)};
  margin-bottom: ${rem(15)};
  background: #434245;
`;

const StyledLabel = styled(Label)`
  min-width: ${rem(225)};
`;

const BottomWrapper = styled.div`
  padding-left: ${rem(20)};
  padding-right: ${rem(20)};
  padding-bottom: ${rem(20)};
`;

const VariantsWrapper = styled.div``;

const ParamWrapper = styled.div`
  padding-right: ${rem(20)};
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(${rem(350)}, ${rem(400)}));
  grid-gap: 0rem;
`;

const Param = styled.div`
  display: flex;
  align-items: center;
`;

const LabelWrapper = styled.div`
  justify-content: flex-end;
  display: flex;
`;

const ParamValueWrapper = styled.div`
  font-size: ${rem(12)};
  width: ${rem(125)};
  display: flex;
  align-items: center;
  margin-left: ${rem(5)};
  color: #434245;
`;

const BigParamValueWrapper = styled(ParamValueWrapper)`
  width: auto;
`;
const CheckBoxesGroup = styled.div`
  margin-top: ${rem(10)};
`;

const CheckItem = styled.div`
  margin-bottom: ${rem(3)};
`;

const BigParamsWrapper = styled.div`
  display: flex;
  align-items: self-start;
`;

class CatalogProductDetail extends React.Component {
  state = {
    paintSystemLoading: true,
    productsLoading: true,
    paintSystem: {},
    products: [],
  };

  async componentDidMount() {
    const id = getIdFromProps(this.props);
    await this.fetchPaintSystem(id);
    await this.fetchLayersProducts(id);
  }

  getValues(type, values, label, selectedUnit) {
    if (
      type === 'checkboxesGroup' ||
      type === 'multiSelect' ||
      type === 'selectGroup'
    ) {
      return (
        <CheckBoxesGroup>
          {(Array.isArray(values) ? values : [values]).map(v => {
            return <CheckItem>{`${v.label} ${selectedUnit || ''}`}</CheckItem>;
          })}
        </CheckBoxesGroup>
      );
    } else if (type === 'codelist') {
      return `${label} ${selectedUnit || ''}`;
    }
    return `${values} ${selectedUnit || ''}`;
  }

  async fetchPaintSystem(id) {
    try {
      const paintSystem = await API2.getB2BPaintSystemAction(id);
      this.setState({
        paintSystem,
        paintSystemLoading: false,
      });
    } catch (e) {
      console.log(e);
    }
  }

  async fetchLayersProducts(id) {
    try {
      const response = await API2.getB2BPaintSystemProductsAction(id);
      this.setState({
        products: response.products || [],
        productsLoading: false,
      });
    } catch (e) {
      console.log(e);
      this.setState({
        productsLoading: false,
      });
    }
  }

  render() {
    const {
      paintSystem,
      products,
      paintSystemLoading,
      productsLoading,
      cartItemsIds,
      cartItems,
      productToAddId,
      showAddToCartProduct,
      showProductAddedPopup,
      error,
    } = this.state;

    if (paintSystemLoading) {
      return (
        <LoaderWrapper>
          <Loader size="xl" color="#70af00" />
        </LoaderWrapper>
      );
    }

    return (
      <React.Fragment>
        <ErrorMessage display={error} text={error} />
        <ErrorMessage
          display={showProductAddedPopup}
          success
          text={__('Produkt bol pridaný do objednávky')}
        />

        <MainWrapper>
          <AlertPopup
            display={showAddToCartProduct}
            alignUnderHeader
            onClose={() =>
              this.setState({
                showAddToCartProduct: false,
                productToAddId: undefined,
              })
            }
            component={
              <ProductQuantitySelect
                items={
                  products &&
                  products.find(v => v._id === productToAddId) &&
                  products.find(v => v._id === productToAddId).Unit_of_Measure
                }
                onSubmit={quantity => this.addToCard(quantity)}
              />
            }
          />

          <BaseInfoWrapper>
            <Title>{`${paintSystem.code} - ${
              paintSystem.producer_code
            }`}</Title>
            <ShortDesc>
              {catalogDescTranslate(
                this.props.appLang,
                paintSystem.short_description_translation,
                paintSystem.short_description,
              )}
            </ShortDesc>
            <Line />

            <Desc>
              {catalogDescTranslate(
                this.props.appLang,
                paintSystem.description_translations,
                paintSystem._description,
              )}
            </Desc>

            <ParamWrapper>
              {paintSystem.params
                .filter(
                  p =>
                    p.value &&
                    (p.value.length > 4 ||
                      Array.isArray(p.value) ||
                      p.value instanceof Object) &&
                    p.type !== 'multiSelect' &&
                    p.type !== 'checkboxesGroup',
                )
                .map(p => {
                  return (
                    <Param>
                      <LabelWrapper>
                        <StyledLabel>{`${p.name}:`}</StyledLabel>
                      </LabelWrapper>
                      <ParamValueWrapper>
                        {this.getValues(
                          p.type,
                          p.value,
                          p.label,
                          p.selectedUnit,
                        )}
                      </ParamValueWrapper>
                    </Param>
                  );
                })}
            </ParamWrapper>

            <ParamWrapper>
              {paintSystem.params
                .filter(
                  p =>
                    p.value &&
                    (p.value.length > 4 ||
                      Array.isArray(p.value) ||
                      p.value instanceof Object) &&
                    (p.type === 'multiSelect' || p.type === 'checkboxesGroup'),
                )
                .map(p => {
                  return (
                    <BigParamsWrapper>
                      <LabelWrapper>
                        <StyledLabel>{`${p.name}:`}</StyledLabel>
                      </LabelWrapper>
                      <BigParamValueWrapper>
                        {this.getValues(
                          p.type,
                          p.value,
                          p.label,
                          p.selectedUnit,
                        )}
                      </BigParamValueWrapper>
                    </BigParamsWrapper>
                  );
                })}
            </ParamWrapper>
          </BaseInfoWrapper>
        </MainWrapper>

        <BottomWrapper>
          <Title>{__('Produkty')}</Title>
          <Line style={{ margin: 0 }} />
          <VariantsWrapper>
            <Products
              data={products}
              loading={productsLoading}
              cartItemsIds={cartItemsIds}
              cartItems={cartItems}
              variantLoadingId={productToAddId}
              addToCart={productId => this.openAddProductToCard(productId)}
            />
          </VariantsWrapper>
        </BottomWrapper>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    ...state,
  };
};

export default connect(mapStateToProps)(CatalogProductDetail);



// WEBPACK FOOTER //
// ./src/Containers/Buy/PaintSystems/Detail/index.jsx